import { Text } from '@mantine/core';
import { FC } from 'react';
import { i18n } from '@lingui/core';
import { ChangeEventStatusConfigDTO, ProcedureReportProps } from '../../../../Types/LogT';

const ChangeEventStatusReport: FC<ProcedureReportProps> = ({ report, config }) => {
  const { bookingState } = config as ChangeEventStatusConfigDTO;

  return (
    <Text>
      Eventstatus wurde auf{'  '}
      <Text span weight="bolder">
        {i18n._(`bookingState.${bookingState}`)}
      </Text>
      {'  '}gesetzt.
    </Text>
  );
};

export default ChangeEventStatusReport;
